module.exports = __webpack_public_path__ + "media/images/pc/plans/inclusion_40-f7bbe743334e1f5d5a3333452ded0b40.png";